import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AnalyticsApiService from '../../ApiServices/AnalyticsApiService/AnalyticsApiService';
import { toast } from 'react-toastify';
import PublisherApiService from '../../ApiServices/PublisherApiService/PublisherApiService';
import { useAuth } from "../Auth/AuthContext";
import WebsiteApiService from '../../ApiServices/WebsiteApiService/WebsiteApiService';
import AdunitApiService from '../../ApiServices/AnalyticsApiService/AdunitApiService';
import AppApiService from '../../ApiServices/WebsiteApiService/AppApiService';

const AddAnalyticsForm = ({ isOpen, onRequestClose, onSubmit }) => {
    const [formData, setFormData] = useState({
        date: new Date(),
        publisherId: '',
        publisher: '',
        websiteId: '',
        website: '',
        adUnits: '',
        adExchangeImpressions: '',
        adExchangeClicks: '',
        adExchangeCTR: '',
        adExchangeRevenue: '',
        adExchangePayout: '',
        adExchangeAvgECPM: '',
        adExchangeAdRequests: '',
        adExchangeMatchRate: '',
        adExchangeFillRate: ''
    });


    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [publishersData, setPublishers] = useState([]);
    const [webData, setWebData] = useState([]);
    const [appData, setAppData] = useState([]);
    const [adunitsData, setadunitsData] = useState([]);

    const { authState } = useAuth();
    const user = authState.user;
    const role = authState.roles;
    const admin = role === "Admin";

    useEffect(() => {
        if (admin) {
            fetchPublishers();
            fetchAdunits();
        }
    }, [admin]);

    const fetchPublishers = async () => {
        try {
            const response = await PublisherApiService.get();
            const formatted = (response.data || []).map((w) => ({
            value: w.id,
            label: w.name
        }));
            setPublishers(formatted || []);
        } catch (error) {
            toast.error("Failed to load publishers");
        }
    };

    const fetchAdunits = async () => {
        setLoading(true);
        try {
            const response = await AdunitApiService.getAll();
            const formatted = (response.data || []).map((w) => ({
            value: w.id,
            label: w.name
        }));
            setadunitsData(formatted || []);
        } catch (error) {
            toast.error('Failed to fetch adunits.');
        } finally {
            setLoading(false);
        }
    };

   
const fetchWebsites = async (publisherId) => {
    if (!publisherId) {
        setWebData([]);
        return;
    }
    try {
        const response = await WebsiteApiService.GetAllWebByUserId(publisherId);
        const formatted = (response.data || []).map((w) => ({
            value: w.websiteId,
            label: w.name || w.url
        }));
        setWebData(formatted);
    } catch (error) {
        toast.error("Failed to load websites");
    }
};

const fetchApps = async (publisherId) => {
    if (!publisherId) {
        setAppData([]);
        return;
    }
    try {
        const response = await AppApiService.GetAllAppByUserId(publisherId);
        const formatted = (response.data || []).map((a) => ({
            value: a.id,
            label: a.name || a.url
        }));
        setAppData(formatted);
    } catch (error) {
        toast.error("Failed to load apps");
    }
};

    const handlePublisherChange = (e) => {
        const publisherId = e.target.value;
        setFormData((prev) => ({ ...prev, publisher: publisherId, website: '', app: '' }));
        fetchWebsites(publisherId);
        fetchApps(publisherId)
    };

    const handleInputChange = (e) => {
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleDateChange = (date) => {
        setFormData((prev) => ({ ...prev, date }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
          debugger
            const sanitizeNumber = (value) => {
                return value === null || value === undefined || value === '' ? 0 : Number(value);
            };

            const obj = {
                publisherId: formData.publisher,
                publisher: formData.publisher,
                website: sanitizeNumber(formData.website ?? ""),
                websiteId: sanitizeNumber(formData.websiteId ?? 0),
                appId: sanitizeNumber(formData.app ?? 0),
                date: new Date(formData.date).toLocaleDateString('en-CA').split('T')[0],
                adUnits: formData.adunit,
                adUnit: formData.adunit,
                adExchangeImpressions: sanitizeNumber(formData.adExchangeImpressions),
                adExchangeClicks: sanitizeNumber(formData.adExchangeClicks),
                adExchangeCTR: sanitizeNumber(formData.adExchangeCTR),
                adExchangeRevenue: sanitizeNumber(formData.adExchangeRevenue),
                adExchangePayout: sanitizeNumber(formData.adExchangePayout),
                adExchangeAvgECPM: sanitizeNumber(formData.adExchangeAvgECPM),
                adExchangeAdRequests: sanitizeNumber(formData.adExchangeAdRequests),
                adExchangeMatchRate: sanitizeNumber(formData.adExchangeMatchRate),
                adExchangeFillRate: sanitizeNumber(formData.adExchangeFillRate),
                country: '',
            };

            await AnalyticsApiService.addAnalytics(obj);
            toast.success("Analytics data added successfully!");

            onSubmit();
            onRequestClose();

        } catch (error) {
            setError(error.message || 'Failed to add analytics data');
        } finally {
            setLoading(false);
        }
    };
const SelectInput = ({ label, name, value, onChange, data = [], required = false }) => (
  <div>
    <label className="block text-sm font-medium mb-1">{label}</label>
    <select
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 transition shadow-sm"
    >
      <option value="">Select {label}</option>
      {data.map((item, index) => (
        <option key={item.value || index} value={item.value}>{item.label}</option>
      ))}
    </select>
  </div>
);



return (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm p-4"
  >
    <div className="bg-white rounded-3xl shadow-2xl p-6 sm:p-8 w-full max-w-4xl relative max-h-[90vh] overflow-hidden flex flex-col animate-fade-slide-up">

      {/* ✖ Close Button */}
      <button
        onClick={onRequestClose}
        className="absolute top-4 right-4 text-gray-400 hover:text-red-500 text-2xl transition-transform hover:scale-110"
        title="Close"
      >
        ✖
      </button>

      {/* 📊 Title */}
      <h2 className="text-3xl font-bold text-center text-indigo-600 mb-6 tracking-tight">Add Analytics</h2>
      {error && <p className="text-red-600 text-center mb-3 font-medium">{error}</p>}

      {/* 📋 Form Section */}
      <div className="overflow-y-auto flex-grow scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-transparent px-1" style={{ maxHeight: "70vh" }}>
        <form onSubmit={handleSubmit} className="space-y-6 text-gray-700">

          {/* 🔗 Adunit & Publisher */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            
            <SelectInput label="Adunit" name="adunit" value={formData.adunit} onChange={handleInputChange} data={adunitsData} required />
            <SelectInput label="Publisher" name="publisher" value={formData.publisher} onChange={handlePublisherChange} data={publishersData} required />
          </div>

          {/* 🔗 App & Website */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <SelectInput label="App" name="app" value={formData.app} onChange={handleInputChange} data={appData} />
            <SelectInput label="Website" name="website" value={formData.website} onChange={handleInputChange} data={webData} />
          </div>

          {/* 📊 Metrics Fields */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {[
              'adExchangeImpressions',
              'adExchangeClicks',
              'adExchangeCTR',
              'adExchangeRevenue',
              'adExchangePayout',
              'adExchangeAvgECPM',
              'adExchangeAdRequests',
              'adExchangeMatchRate',
              'adExchangeFillRate'
            ].map((field) => (
              <div key={field}>
                <label className="block text-sm font-medium mb-1 capitalize">{field.replace(/([A-Z])/g, ' $1')}</label>
                <input
                  type="number"
                  name={field}
                  value={formData[field]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 transition shadow-sm"
                />
              </div>
            ))}
            {/* 📅 Date */}
            <div>
              <label className="block text-sm font-medium mb-1">Date</label>
              <DatePicker
                selected={formData.date}
                onChange={handleDateChange}
                required
                className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 transition shadow-sm"
              />
            </div>
          </div>

          {/* 🎯 Actions */}
          <div className="flex justify-center gap-6 pt-6">
            <button
              type="button"
              onClick={onRequestClose}
              className="bg-gray-100 text-gray-700 px-6 py-2 rounded-xl font-semibold hover:bg-gray-200 hover:scale-105 transition transform"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-6 py-2 rounded-xl font-semibold shadow-md hover:scale-105 hover:shadow-xl transition transform"
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  </Modal>
);

};

export default AddAnalyticsForm;
